import { render } from "./Page9.vue?vue&type=template&id=125a1118&scoped=true"
import script from "./Page9.vue?vue&type=script&lang=js"
export * from "./Page9.vue?vue&type=script&lang=js"

import "./Page9.vue?vue&type=style&index=0&id=125a1118&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125a1118"]])

export default __exports__